/**
 * WarningPanel — renders a collapsible list of warning strings.
 * Used on report, statement, documents, and recurring pages.
 */

interface WarningPanelProps {
  warnings: string[];
  label?: string;
}

export function WarningPanel({
  warnings,
  label = "Warnings",
}: WarningPanelProps) {
  if (warnings.length === 0) return null;

  return (
    <div className="warning-panel" role="alert">
      <h3 className="warning-panel__title">{label}</h3>
      <ul className="warning-panel__list">
        {warnings.map((w, i) => (
          <li key={i} className="warning-panel__item">
            {w}
          </li>
        ))}
      </ul>
    </div>
  );
}
